import React, { Component } from 'react'
import { HashRouter, Route, Redirect, Switch } from 'react-router-dom'
import { ScrollToTop } from '../components/ScrollToTop'
import { connect } from 'react-redux'
import MainTemplate from '../templates/MainTemplate'
import HomePage from '../modules/home/HomePage'
import ExamConfigPage from '../modules/exam/ExamConfigPage'
import ExamPage from '../modules/exam/ExamPage'
import QuestionResultPage from '../modules/exam/QuestionResultPage'
import { setUser, signOut } from '../modules/account/accountActions'
import ReactGA from 'react-ga';
import PropTypes from 'prop-types'
import {withRouter} from 'react-router-dom';
import { MySimulates } from '../modules/exam/MySimulates/index'
import FinishedSimulate from '../modules/exam/FinishedSimulate'
import SpecificSimulate from '../modules/exam/SpecificSimulate'

ReactGA.initialize('UA-101122498-1');

class Routes extends Component {
    componentDidMount() {
        if (this.props.user && !this.props.user.keepConnect) {
            window.addEventListener('beforeunload', this.props.signOut());
        }
    }

    componentWillMount() {
        if (!this.props.user) {
			if (localStorage.bedukaUser) {
				const user = JSON.parse(localStorage.bedukaUser);
				this.props.setUser(user);
			}
		}
	}
	
	componentWillReceiveProps(nextProps) {
		if (!nextProps.user) {
			if (localStorage.bedukaUser) {
				const user = JSON.parse(localStorage.bedukaUser);
				this.props.setUser(user);
			}
		}
	}
    
    render() {
        const PrivateRoute = ({ component: Component, render, ...rest }) => {
			if (render && !localStorage.bedukaUser) {
				render = props => <Redirect
                    to={{
                        pathname: "/",
                        state: { from: props.location }
                    }}
				/>
			}
			return (
				<Route
					{...rest}
					render={render 
						? render 
						: props =>
							localStorage.bedukaUser ? (
								<Component {...props} />
							) : (
								<Redirect
                                    to={{
                                        pathname: "/",
                                        state: { from: props.location }
                                    }}
								/>
							)
					}
				/>
			)
            
        };
        
        return (
            <HashRouter>
                <Switch>
                    <ScrollToTop>
                        <GAListenerWithRouter>
                            <MainTemplate>
                                <Switch>
                                    <Route exact path="/" component={HomePage} />
                                    <PrivateRoute exact path="/monte-seu-simulado" component={ExamConfigPage} />
                                    <Redirect exact path="/questao" to="/questao/1" />
                                    <PrivateRoute exact path="/questao/:id" component={ExamPage} />

                                    <PrivateRoute exact path="/resultado" component={FinishedSimulate} />
                                    <PrivateRoute exact path="/resultado-simulado/:id" component={SpecificSimulate} />

                                    <PrivateRoute exact path="/resultado/:id" component={QuestionResultPage} />
                                    <PrivateRoute exact path="/meus-simulados" component={MySimulates}/>
                                </Switch>
                            </MainTemplate>
                        </GAListenerWithRouter>
                    </ScrollToTop>
                </Switch>
            </HashRouter>
        )
    }
}


const mapStateToProps = state => ({
    user: state.account.user
});

const GAListenerWithRouter = withRouter(props => <GAListener {...props}/>);

class GAListener extends React.Component {
    static contextTypes = {
      router: PropTypes.object
    };
  
    componentDidMount() {
      this.sendPageView(this.props.location.pathname);
    }

    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
          this.sendPageView(this.props.location.pathname);
        }
    }
    
  
    sendPageView(location) {
        ReactGA.set({ page: '/simulado' + location });
        if(location.includes('questao'))
            ReactGA.pageview('/simulado/questao')
        else
            ReactGA.pageview('/simulado' + location);
    }
  
    render() {
      return this.props.children;
    }
}

export default connect(mapStateToProps, { setUser, signOut })(Routes)
